import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
const routes = {
  cart: () => 'cart',
  cartItem: () => 'cartItem'
}

@Injectable({
  providedIn: 'root'
})

export class CartService {
  private cartUpdateSubject = new Subject();
  onCartUpdate = this.cartUpdateSubject.asObservable();

  constructor(private apiService: ApiService) { }

  notifyCartUpdate(source: any) {
    this.cartUpdateSubject.next(source);
  }

  getCartItemCount(cartId: number) {
    return this.apiService.get(`${routes.cartItem()}/count?cartId=${cartId}`);
  }

  getCartItems(cartId: number) {
    return this.apiService.get(`${routes.cartItem()}?cartId=${cartId}`);
  }

  addCartItem(model: any) {
    return this.apiService.post(`${routes.cartItem()}`, model);
  }

  updateCartItem(model: any) {
    return this.apiService.put(`${routes.cartItem()}`, model);
  }

  deleteCartItem(cartItemId: number) {
    return this.apiService.delete(`${routes.cartItem()}?id=${cartItemId}`);
  }

  checkout(model: any) {
    return this.apiService.post(`${routes.cart()}/checkout`, model);
    }

  getMaxCap(companyId: number) {
    return this.apiService.get(`${routes.cart()}/getmaxcap?companyId=${companyId}`);
  }
}
